import React from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import ProductTabMobile from '../../../../components/Sangjo-Ujieon/ProductTabMobile';

const EventProcedureMobile = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="상품안내" />

        {/* Event Procedure Section */}
        <section className="event-procedure-mobile-section sky-hall-special-room-mobile-pricing-section">
          <ProductTabMobile selectedHall="행사절차" />



          {/* Content Sections - Event Procedure specific content */}
          <div className="event-procedure-mobile-content-sections">
            {/* Header Section */}
            <div className="event-procedure-mobile-header-section">
              <div className="event-procedure-mobile-header-text">
                <span className="event-procedure-mobile-teal-text">장례컨설팅부터 추모원까지</span> <br /> 고객님과 슬픔을 함께 나누어 드립니다.
              </div>
            </div>

            {/* Three Column Content */}
            <div className="event-procedure-mobile-content-grid">
              {/* First Column */}
              <div className="event-procedure-mobile-column">
                <div className="event-procedure-mobile-image-container">
                  <img
                    src="/images/pa1.png"
                    alt="Day of passing"
                    className="event-procedure-mobile-image"
                  />
                  <div className="event-procedure-mobile-day-badge">1일차</div>
                </div>
                <div className="event-procedure-mobile-text-content">
                  <h3 className="event-procedure-mobile-column-title">임종일</h3>
                  <p className="event-procedure-mobile-column-text">
                    접수 및 긴급출동, 장례식장 섭외, 수시, 위패 및 제단 설치, 장례절차 협의부고안내, 화장예약
                  </p>
                </div>
              </div>

              {/* Second Column */}
              <div className="event-procedure-mobile-column">
                <div className="event-procedure-mobile-image-container">
                  <img
                    src="/images/pa2.png"
                    alt="Day of encoffinment"
                    className="event-procedure-mobile-image"
                  />
                  <div className="event-procedure-mobile-day-badge">2일차</div>
                </div>
                <div className="event-procedure-mobile-text-content">
                  <h3 className="event-procedure-mobile-column-title">입관일</h3>
                  <p className="event-procedure-mobile-column-text">
                    입관준비, 염습/입관, 상복착용(성복례), 접객요령 안내, 도우미 배치
                  </p>
                </div>
              </div>

              {/* Third Column */}
              <div className="event-procedure-mobile-column">
                <div className="event-procedure-mobile-image-container">
                  <img
                    src="/images/pa3.png"
                    alt="Day of funeral procession"
                    className="event-procedure-mobile-image"
                  />
                  <div className="event-procedure-mobile-day-badge">3일차</div>
                </div>
                <div className="event-procedure-mobile-text-content">
                  <h3 className="event-procedure-mobile-column-title">발인일</h3>
                  <p className="event-procedure-mobile-column-text">
                    선도차 장식, 발인례/발인정산(후불정산), 장지/화장장, 제례, 혼백수습 후 귀가
                  </p>
                </div>
              </div>
            </div>


          </div>

        </section>
      </main>
    </div>
  );
};

export default EventProcedureMobile; 